// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import Image from 'components/common/Image';
import cbsParamountLogo from 'assets/images/tile/CBS_Paramount_logo.png';

import { Brand } from 'models/propTypes/tile';
import BrandLogo from './BrandLogo';

import styles from './BrandedAuthTile.module.scss';

const messages = {
  authText: {
    id: 'tile.auth.text',
    description: 'Auth text for Media Tile',
  },
};

const BrandedAuthTile = ({ authenticated, authTypes, brand, hasFocus }) => {
  const intl = useIntl();
  return (
    <div
      className={classNames(
        'w-100',
        'h-100',
        styles.authOverlay,
        authenticated ? styles.authN : styles.noAuthN,
        {
          [styles.unfocused]: !hasFocus,
        },
      )}
      data-testid="auth-overlay"
    >
      <div>{intl.formatMessage(messages.authText)}</div>
      {authTypes.includes('paramountplus') && authTypes.includes('adobe') ? (
        <Image
          alt="mvpd paramount logo"
          src={cbsParamountLogo}
          className={styles.mvpdParamountLogo}
          data-testid="mvpd-paramount-logo"
        />
      ) : (
        brand && (
          <BrandLogo
            className={styles.authLogo}
            brand={brand}
            fixedSize={false}
          />
        )
      )}
    </div>
  );
};

BrandedAuthTile.propTypes = {
  authenticated: PropTypes.bool,
  authTypes: PropTypes.arrayOf(PropTypes.string),
  brand: Brand,
  hasFocus: PropTypes.bool,
};

BrandedAuthTile.defaultProps = {
  authenticated: false,
  authTypes: [],
  brand: null,
  hasFocus: false,
};

export default BrandedAuthTile;
